import { render, staticRenderFns } from "./ShortHeader.vue?vue&type=template&id=603d1468&scoped=true"
import script from "./ShortHeader.vue?vue&type=script&lang=js"
export * from "./ShortHeader.vue?vue&type=script&lang=js"
import style0 from "./ShortHeader.vue?vue&type=style&index=0&id=603d1468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603d1468",
  null
  
)

export default component.exports